// extracted by mini-css-extract-plugin
export default {"contactPara":"Contact_contactPara__hJltX"};